var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 39,
    rx: 19.5,
    fill: "#95A5B7",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3553 15.741C27.3655 15.8831 27.3655 16.0253 27.3655 16.1674C27.3655 20.5024 24.066 25.4973 18.0355 25.4973C16.1777 25.4973 14.4518 24.9593 13 24.0253C13.264 24.0557 13.5177 24.0659 13.7919 24.0659C15.3248 24.0659 16.736 23.5481 17.8629 22.6649C16.4213 22.6344 15.2132 21.6903 14.7969 20.3908C15 20.4212 15.203 20.4415 15.4162 20.4415C15.7107 20.4415 16.0051 20.4009 16.2792 20.3298C14.7767 20.0253 13.6497 18.7055 13.6497 17.1116V17.071C14.0862 17.3146 14.5939 17.4669 15.1319 17.4872C14.2487 16.8983 13.67 15.8933 13.67 14.7562C13.67 14.1471 13.8324 13.5887 14.1167 13.1014C15.7309 15.0913 18.1573 16.3907 20.8781 16.5329C20.8274 16.2892 20.7969 16.0354 20.7969 15.7816C20.7969 13.9745 22.2588 12.5024 24.0761 12.5024C25.0202 12.5024 25.873 12.8984 26.472 13.538C27.2131 13.3958 27.9238 13.1217 28.5532 12.7461C28.3096 13.5075 27.7918 14.1471 27.1116 14.5532C27.7715 14.4822 28.4111 14.2994 28.9999 14.0456C28.5533 14.6953 27.9949 15.274 27.3553 15.741Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.c180026a30308e603ba0d60f850d2442.svg";
export { ForwardRef as ReactComponent };